// extracted by mini-css-extract-plugin
module.exports = {"pageNotFound":"page-not-found_pageNotFound__1vKzS"};